import React from 'react'
import classNames from 'classnames'
import { Button } from 'antd'
import conf from 'conf'
import { useTranslation } from 'react-i18next'
import { authClientRequiredToken } from 'myNet'
import store from 'store'
import styles from '../style.module.scss'

const AccountRender = (props) => {
  const { messageApi } = props
  const { t } = useTranslation()

  // OFFICENEXT 비밀번호 변경 — `officenext-password-change-guide.md` 참조.
  // 1) safebox 백엔드 proxy 로 password_change_url 발급
  // 2) message 리스너 등록 (common-auth origin + payload 검증)
  // 3) 팝업 open, OFFICENEXT 가 redirect_uri 로 돌아오면 common-auth callback 이
  //    부모창에 postMessage + 자신은 닫음 → 리스너가 ack 받고 UI 갱신.
  const handleChangePassword = async () => {
    let popup = null
    let pollId = null
    const trustedOrigin = new URL(conf.SERVER.authURL).origin

    const cleanup = () => {
      window.removeEventListener('message', handleMessage)
      if (pollId) {
        clearInterval(pollId)
        pollId = null
      }
    }

    function handleMessage(event) {
      if (event.origin !== trustedOrigin) return
      let msg
      try {
        msg = typeof event.data === 'string' ? JSON.parse(event.data) : event.data
      } catch (e) {
        return
      }
      if (msg?.event !== 'password_changed' || msg?.status !== 'success') return
      messageApi.success(t('appConfig.result.successChangePassword'))
      cleanup()
    }

    try {
      const officenextAccessToken = store.get('app.user.providerToken')
      if (!officenextAccessToken) {
        messageApi.error(t('appConfig.settings.failedChangePassword'))
        return
      }

      const res = await authClientRequiredToken.post('/auth/password-change-url', {
        officenext_access_token: officenextAccessToken,
        redirect_uri: `${conf.SERVER.authURL}/auth/password-change-callback`,
      })
      const url = res?.data?.data?.password_change_url
      if (!url) {
        messageApi.error(t('appConfig.settings.failedChangePassword'))
        return
      }

      window.addEventListener('message', handleMessage)

      popup = window.open(url, 'password-change', 'width=500,height=700')
      if (!popup) {
        cleanup()
        messageApi.warning(t('appConfig.settings.popupBlocked'))
        return
      }

      pollId = setInterval(() => {
        if (popup.closed) cleanup()
      }, 500)
    } catch (err) {
      console.error('password-change-url 발급 실패', err)
      cleanup()
      messageApi.error(t('appConfig.settings.failedChangePassword'))
    }
  }

  return (
    <div className={classNames(styles.tabItem, styles.generalContent)}>
      <div className={classNames(styles.content)}>
        <span>{t('appConfig.settings.password')}</span>
        <Button
          className={classNames('h38', styles.changePasswordBtn)}
          onClick={handleChangePassword}
        >
          {t('appConfig.settings.changePassword')}
        </Button>
      </div>
    </div>
  )
}

export default AccountRender
